// Export the Component Definition for use in Contentful Studio
export {CardContentfulComponentDefinition} from './cardContentfulDefinition';
export {default} from './Card';
